<button class="btn btn-primary btn-sm" title="view payments" (click)="viewPayments($event)">View</button>
<!--accepted payments-->
<ng-template #accptedPayments let-modal class="col-12">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Submitted RTMP requests</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalReference.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body"> 
    <div>
      <div class="row">
        <div class="col-12 form-group form-inline">
          <div class="control-label col-sm-3">IBRA Subregion:</div>
          <div>{{obligation.ibraSubregion}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group form-inline">
          <div class="control-label col-sm-3">Credit category:</div>
          <div>{{obligation.creditCategory}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group form-inline">
          <div class="control-label col-sm-3">Credit type ID:</div>
          <div>{{obligation.creditTypeId}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group form-inline">
          <div class="control-label col-sm-3">Offset trading group:</div>
          <div>{{obligation.offsetTradingGroup}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group form-inline">
          <div class="control-label col-sm-3">HBT status:</div>
          <div>{{obligation.hbt}}</div>
        </div>
      </div>
    </div>
    <div>
      <ag-grid-angular style="height:350px;width:75%"
          class="ag-theme-alpine"
          [rowData]="acceptedObligations"
          [columnDefs]="acceptedPaymentsColumnDefs"
          [pagination]="true"
          (gridReady)="onGridReady($event)">
          [defaultColDef]="defaultColDef">
      </ag-grid-angular>
    </div>
  
  </div>
</ng-template>
